module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-6-m3.ae7b42d3.jpg";